import { useLingui } from '@lingui/react/macro'


import Link from '@/components/Link';
import { cls } from 'tagged-classnames-free';
interface IMoreReviewProps {
  title?: string
  data: {
    attributes: {
      h1: string
      url: string
    }
  }[]
}

export const MoreReview: React.FC<IMoreReviewProps> = (props) => {
  const { t } = useLingui()

  const { title = t`Generate Full Songs in Seconds With LoudMe`, data } = props

  return (
    <div className='mx-auto max-w-[932px] px-4 pt-[136px]'>
      <h2 className='text-f-text text-center text-4xl font-semibold'>
        {title}
      </h2>
      <div className='flex flex-wrap items-center justify-center gap-2 pt-8'>
        {data.map((item) => {
          return (
            <Link
              key={item.attributes.h1}
              href={item.attributes.url}
              className={cls`bg-f-bg-active text-f-text-secondary hover:text-f-primary px-2 py-1 text-xs font-semibold`}
            >
              {item.attributes.h1}
            </Link>
          )
        })}
      </div>
    </div>
  )
}
